__turbopack_context__.v({
  "checkbox": "FormCall-module-scss-module__4Tt4Zq__checkbox",
  "checkbox__input": "FormCall-module-scss-module__4Tt4Zq__checkbox__input",
  "formCallBtnBox": "FormCall-module-scss-module__4Tt4Zq__formCallBtnBox",
  "formCallBtnText": "FormCall-module-scss-module__4Tt4Zq__formCallBtnText",
  "formCallContainer__bigForm": "FormCall-module-scss-module__4Tt4Zq__formCallContainer__bigForm",
  "formCallForm": "FormCall-module-scss-module__4Tt4Zq__formCallForm",
  "formCallInputBox": "FormCall-module-scss-module__4Tt4Zq__formCallInputBox",
  "formCallTextarea": "FormCall-module-scss-module__4Tt4Zq__formCallTextarea",
  "formCallTextareaError": "FormCall-module-scss-module__4Tt4Zq__formCallTextareaError",
  "formCallThanksText": "FormCall-module-scss-module__4Tt4Zq__formCallThanksText",
  "formCallTitle": "FormCall-module-scss-module__4Tt4Zq__formCallTitle",
  "formCallTitle__bigForm": "FormCall-module-scss-module__4Tt4Zq__formCallTitle__bigForm",
  "formWrapper": "FormCall-module-scss-module__4Tt4Zq__formWrapper",
  "hiddenField": "FormCall-module-scss-module__4Tt4Zq__hiddenField",
});
